import {
    ACTION_GET_STAR_ASSIGNMENT_REPORT_LIST,
    ACTION_GET_STARASSIGNMENT_LIST,
    SET_STARASSIGNMENT_LIST,

    ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY,
    SET_STARASSIGNMENT_TYPE_CATEGORY,

    ACTION_POST_STARASSIGNMENT_ALL,
    ACTION_POST_STARASSIGNMENT_INDIVIDUAL,

    ACTION_GET_CARDSlIST,
    SET_CARDSLIST,

    ACTION_GET_STARTYPE_LIST,
    SET_STARTYPES_LIST,

    ACTION_GET_LIST_HISTORICAL_TEMPLATE,
    SET_LIST_HISTORICAL_TEMPLATE,

    ACTION_POST_TEMPLATE,
    SET_POST_TEMPLATE,

    ACTION_DOWNLOAD_TEMPLATE,
    SET_DOWNLOAD_TEMPLATE,

    ACTION_GET_TYPE_STAR_LIST,
    SET_LIST_TYPE_STAR_LIST,

    ACTION_POST_ZEN_STAR,
    SET_ZEN_STAR_REQUESTS,

    ACTION_STAR_ZEN_STATUS,
    SET_STAR_ZEN_STATUS,

    ACTION_LIST_ZEN_STAR_REQUESTS,
    ACTION_POST_STAR_ZEN_STATUS,

    ACTION_GET_JOB_STATUS,
    SET_JOB_STATUS,

} from "@/views/star_assignment/store/types/types.js";

import { StarAssignmentService } from "../../../services";
import i18n from '@/plugins/i18n';
import Swal from 'sweetalert2';

const actions = {

    [ACTION_GET_STARASSIGNMENT_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getTypeDocumentStarAssignment(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeDocumentStarassignment = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_STARASSIGNMENT_LIST, typeDocumentStarassignment);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_STAR_ASSIGNMENT_REPORT_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getRecognitionAssignmentTypeReport(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            commit(SET_STARASSIGNMENT_LIST, resp.data.payload);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_STARTYPE_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getTypeStar(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeStara = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_STARTYPES_LIST, typeStara);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getCategoryStarAssignment(idGroup, idEmpresa, idUsuario)
                    .then(resp => {

                        const typeCategoryStarAssignment = resp.data.payload;
                        commit(SET_STARASSIGNMENT_TYPE_CATEGORY, typeCategoryStarAssignment);
                        resolve(resp)
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_STARASSIGNMENT_ALL]: ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingZen = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.postStarAssignmentAll({ idGroup, idEmpresa, idUsuario, data })
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: resp.data.payload.message,
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                            window.location.reload();
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loadingZen = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_STARASSIGNMENT_INDIVIDUAL]: ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.postStarAssignmentInd({ idGroup, idEmpresa, idUsuario, data })
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: resp.data.payload.message,
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                            window.location.reload();
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CARDSlIST]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {

                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                StarAssignmentService.getCardsList(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_CARDSLIST, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_LIST_HISTORICAL_TEMPLATE]:({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getAllTemplates(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        const template = resp.data.payload;
                        commit(SET_LIST_HISTORICAL_TEMPLATE, template);
                        resolve(resp.data.payload);
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_TEMPLATE]:({ state, commit }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                StarAssignmentService.scatterStarsTemplates(idGroup, companyId, userId, data)
                    .then(async resp => {
                        commit(SET_POST_TEMPLATE, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });

    },

    [ACTION_DOWNLOAD_TEMPLATE]:({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                StarAssignmentService.downloadTemplate(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_DOWNLOAD_TEMPLATE, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });

    },

    [ACTION_GET_TYPE_STAR_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
               
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getTypeStarList(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const listTypeStar = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_LIST_TYPE_STAR_LIST, listTypeStar);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

     [ACTION_POST_ZEN_STAR]: async ({ state }, data) => {
    
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
    
                StarAssignmentService.postRequestsZen( idGroup, idEmpresa, idUsuario, data )
                    .then(async resp => {
                        if (resp?.data?.payload) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: resp.data.payload.message,
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp.data.payload);
                            window.location.reload();
                        }})
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_LIST_ZEN_STAR_REQUESTS]: async ({ state, commit }) => {
    
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
    
                StarAssignmentService.getListRequestsZen( idGroup, idEmpresa, idUsuario )
                    .then(async resp => {
                        if (resp?.data?.payload) {  
                            const requestsZen = resp.data.payload;
                            commit(SET_ZEN_STAR_REQUESTS, requestsZen);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_STAR_ZEN_STATUS]: async ({ state, commit }) => {
    
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
    
                StarAssignmentService.getListStarZenStatus(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp?.data?.payload && Array.isArray(resp.data.payload)) {
    
                            const liststarZenStatus = resp.data.payload.map((e, i) => {
                                return {
                                    ...e,
                                    activeDialogClient: false,
                                    index: i
                                };
                            });
    
                            commit(SET_STAR_ZEN_STATUS, liststarZenStatus);
                            resolve(resp.data.payload);
    
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
    
    [ACTION_POST_STAR_ZEN_STATUS]: async ({ state }, data) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
                StarAssignmentService.postStarZenStatus({ idGroup, idEmpresa, idUsuario, data })
                    .then(async (resp) => {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: resp.data.payload.messageFeedback,
                            showConfirmButton: false,
                            timer: 2500
                        });

                        resolve(resp);
                        window.location.reload();

                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_JOB_STATUS]: ({ commit }, jobId) => {
        return new Promise((resolve, reject) => {
            try {
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getJobStatus(idGroup, idEmpresa, idUsuario, jobId)
                    .then(resp => {
                        commit(SET_JOB_STATUS, resp.data.payload);
                        resolve(resp.data.payload);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

}

export default actions;